import { Word } from '.'

export const DEFAULT_WORDS = [
  { start: 0.612, end: 1.175, text: 'Oh,' },
  { start: 1.687, end: 2.002, text: 'I' },
  { start: 2.02, end: 2.107, text: 'think' },
  { start: 2.11, end: 2.232, text: "it's" },
  { start: 2.247, end: 2.422, text: 'just' },
  { start: 2.455, end: 2.602, text: 'really' },
  { start: 2.62, end: 2.797, text: 'cool' },
  { start: 2.83, end: 3.022, text: 'that' },
  { start: 3.055, end: 3.477, text: "everybody's" },
  { start: 3.507, end: 3.607, text: 'going' },
  { start: 3.61, end: 3.682, text: 'to' },
  { start: 3.685, end: 3.757, text: 'be' },
  { start: 3.76, end: 3.922, text: 'able' },
  { start: 3.955, end: 4.102, text: 'to' },
  { start: 4.12, end: 4.787, text: 'flex' },
  { start: 5.437, end: 5.752, text: 'their' },
  { start: 5.77, end: 6.162, text: 'entities' },
  { start: 6.237, end: 6.427, text: 'on' },
  { start: 6.445, end: 6.622, text: 'their' },
  { start: 6.655, end: 7.377, text: 'Merch.' },
  { start: 7.557, end: 8.347, text: 'And' },
  { start: 8.53, end: 8.827, text: 'a' },
  { start: 8.845, end: 8.977, text: 'lot' },
  { start: 8.995, end: 9.082, text: 'of' },
  { start: 9.085, end: 9.292, text: 'people' },
  { start: 9.34, end: 9.547, text: 'were' },
  { start: 9.58, end: 9.817, text: 'saying' },
  { start: 9.865, end: 10.475, text: 'that' },
  { start: 11.062, end: 11.502, text: 'Merch' },
  { start: 11.532, end: 12.172, text: 'is' },
  { start: 12.355, end: 12.697, text: 'not' },
  { start: 12.73, end: 12.922, text: 'that' },
  { start: 12.955, end: 13.102, text: 'big' },
  { start: 13.12, end: 13.252, text: 'of' },
  { start: 13.27, end: 13.357, text: 'a' },
  { start: 13.359, end: 13.722, text: 'utility.' },
  { start: 13.767, end: 13.927, text: 'But' },
  { start: 13.945, end: 14.077, text: 'in' },
  { start: 14.095, end: 14.272, text: 'my' },
  { start: 14.305, end: 14.621, text: 'opinion,' },
  { start: 14.667, end: 14.782, text: 'I' },
  { start: 14.785, end: 14.947, text: 'think' },
  { start: 14.98, end: 15.127, text: 'it' },
  { start: 15.145, end: 15.682, text: 'is,' },
  { start: 15.835, end: 16.372, text: 'because' },
  { start: 16.48, end: 16.747, text: 'our' },
  { start: 16.78, end: 17.097, text: 'bodies' },
  { start: 17.142, end: 17.302, text: 'are' },
  { start: 17.32, end: 17.666, text: 'literally' },
  { start: 17.727, end: 18.027, text: 'walking' },
  { start: 18.057, end: 18.987, text: 'billboards.' },
  { start: 19.137, end: 19.672, text: 'And' },
  { start: 19.78, end: 20.352, text: 'literally,' },
  { start: 20.457, end: 20.677, text: 'as' },
  { start: 20.695, end: 20.872, text: 'you' },
  { start: 20.905, end: 21.097, text: 'walk' },
  { start: 21.13, end: 21.682, text: 'around,' },
  { start: 21.835, end: 22.147, text: 'like,' },
  { start: 22.18, end: 22.372, text: 'just' },
  { start: 22.405, end: 22.597, text: 'going' },
  { start: 22.63, end: 22.822, text: 'about' },
  { start: 22.855, end: 23.002, text: 'your' },
  { start: 23.02, end: 23.322, text: 'daily' },
  { start: 23.367, end: 24.022, text: 'life,' },
  { start: 24.205, end: 24.592, text: 'people' },
  { start: 24.64, end: 24.847, text: 'will' },
  { start: 24.88, end: 25.117, text: 'start' },
  { start: 25.165, end: 25.507, text: 'seeing' },
  { start: 25.585, end: 25.777, text: 'what' },
  { start: 25.795, end: 25.977, text: "you're" },
  { start: 26.007, end: 26.291, text: 'wearing' },
  { start: 26.352, end: 26.842, text: 'and' },
  { start: 26.965, end: 27.382, text: 'asking' },
  { start: 27.46, end: 27.787, text: 'questions' },
  { start: 27.85, end: 28.027, text: 'and' },
  { start: 28.045, end: 28.177, text: 'being' },
  { start: 28.195, end: 28.327, text: 'like,' },
  { start: 28.344, end: 28.522, text: 'what' },
  { start: 28.555, end: 28.702, text: 'is' },
  { start: 28.719, end: 28.942, text: 'that?' },
  { start: 28.99, end: 29.287, text: 'And' },
  { start: 29.35, end: 29.527, text: 'it' },
  { start: 29.545, end: 29.832, text: 'allows' },
  { start: 29.847, end: 29.925, text: 'you.' },
] satisfies Word[]
